

window.addEventListener('DOMContentLoaded', (e)=>{
  
  BundleGWPCheck();
  
  function BundleGWPCheck(){

    var buildEvent,bundleGift,giftID,bundleKit,bundleColor,removeGift;
    
    initialize();

    function initialize(){

      buildEvent = new Event('cart:build');

      theme.cart.getCart().then( (cart) =>{
        if(cart.items)
          execute(cart.items);
      });  
      
      document.addEventListener('cart:updated', (e)=>{                        
        if(e.detail.cart.items)
          execute(e.detail.cart.items);                    
      });                          
    }
    
    function execute(cartItems){
          
      checkCartforBundleItems(cartItems);
      checkGiftRemovalConditions();
      
      if(removeGift){                 
        removeBundleGift();
      }
                          
    }

    function checkCartforBundleItems(cartItems){
      
      var i,item,bundleProperty;

      bundleGift = false;
      bundleKit = false;
      bundleColor = false;
      bundleComplete =false;
      
      i=0;      
      item = cartItems[i];
        
      while(item){
        
        bundleProperty = item.properties['_bundleItem'];

        if(bundleProperty){
          
          switch(bundleProperty){
  
            case 'Free Gift':  
              bundleGift = true;              
              giftID = item.id.toString();
              break;
              
            case 'Color':
              bundleColor = true; 
              break;
  
            case 'Lighten': 
              bundleKit = true; 
              break;
              
          }
          
        }
        
        i++;
        item = cartItems[i];
        
      }
      
    }

    function checkGiftRemovalConditions(){                  
      if(bundleGift && (!bundleColor || !bundleKit ) ){
        removeGift = true;
      }
    }

    function removeBundleGift(){
      theme.cart.changeItem(giftID, 0).then( ()=>{
        document.dispatchEvent(buildEvent);
      });
    }
    
    
  }
  
});